import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-img',
    templateUrl: './tp-img.component.html',
    styleUrls: ['./tp-img.component.scss']
})
export class TpImgComponent {
    @Input() public src: string;
    @Input() public alt: string;
}
